import { createApp } from 'vue';
import App from '../views/Routemap.vue';

const mapElement = document.getElementById('vue-map');
if (mapElement) {
	// Routemap.vue fetches its own data (routes/favourites/registrations) in
	// created() and gates its template on dataReady, so it can mount right
	// away here instead of waiting on those fetches first.
	createApp(App).mount('#vue-map');
}
